import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "max-w-[1180px]" }
const _hoisted_2 = {
  class: "mb-8 flex flex-wrap",
  "aria-label": "Order tabs"
}
const _hoisted_3 = ["data-key", "aria-current", "onClick"]
const _hoisted_4 = { class: "ml-2 h-6 rounded-md bg-gray-200 px-1 py-0.5 text-sm font-semibold" }
const _hoisted_5 = { key: 0 }

import { onMounted, reactive, ref } from 'vue'

import BasicSpinner from '@/components/BasicSpinner.vue'
import FranchiseDayBottleList from '@/components/franchise/FranchiseDayBottleList.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { ORDER_TABS } from '@/composables/useFranchiseDay'


export default {
  __name: 'FranchiseDayOrders',
  props: { day: { type: Object, required: true } },
  setup(__props) {

const props = __props

const EMPTY_LABELS = {
  all: 'orders',
  unpacked: 'unpacked orders',
  packed: 'packed orders',
  cancelled: 'cancelled orders'
}

// The status each packing sub-tab moves a bottle to, and the button that does it.
const PACK_ACTIONS = {
  unpacked: { status: 'packed', label: 'Mark as packed' },
  packed: { status: 'not_produced', label: 'Mark not packed' }
}

const current = ref('all')
const packing = reactive({})

const setStatus = (bottle, status) => {
  packing[bottle.id] = true
  const done = () => delete packing[bottle.id]
  // A failed write leaves the row where it was, ready to try again.
  return props.day.setProductionStatus(bottle, status, current.value).then(done, done)
}

// Every sub-tab loads up front, so each shows its count before it is opened.
onMounted(() => ORDER_TABS.forEach(tab => props.day.loadOrders(tab.id)))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ORDER_TABS), (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          type: "button",
          "data-test": "orders-tab",
          "data-key": tab.id,
          class: _normalizeClass([
          current.value === tab.id ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
          'mr-4 flex items-center rounded-md px-3 py-2 text-sm font-medium'
        ]),
          "aria-current": current.value === tab.id ? 'page' : undefined,
          onClick: $event => (current.value = tab.id)
        }, [
          _createTextVNode(_toDisplayString(tab.name) + " ", 1),
          _createElementVNode("span", _hoisted_4, [
            (__props.day.orders[tab.id].size != null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.day.orders[tab.id].size), 1))
              : (_openBlock(), _createBlock(BasicSpinner, {
                  key: 1,
                  size: "small"
                }))
          ])
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createVNode(FranchiseDayBottleList, {
      list: __props.day.orders[current.value],
      "location-name": __props.day.locationName,
      "empty-label": EMPTY_LABELS[current.value],
      onPrev: _cache[0] || (_cache[0] = ret => __props.day.prevOrders(current.value).then(ret)),
      onNext: _cache[1] || (_cache[1] = ret => __props.day.nextOrders(current.value).then(ret))
    }, {
      actions: _withCtx(({ bottle }) => [
        (PACK_ACTIONS[current.value])
          ? (_openBlock(), _createBlock(NeueButton, {
              key: 0,
              "data-test": "pack-button",
              type: "secondary",
              size: "sm",
              disabled: !!packing[bottle.id],
              onClick: $event => (setStatus(bottle, PACK_ACTIONS[current.value].status))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(PACK_ACTIONS[current.value].label), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["list", "location-name", "empty-label"])
  ]))
}
}

}